<template>
  <div class="review-analysis-header" v-loading="loading">
    <el-row :gutter="10">
      <el-col :span="6">
        <div class="review-analysis-header-item item-0">
          <div class="review-analysis-header-title">
            Review数量
          </div>
          <div class="review-analysis-header-number">
            {{ data.count}}
          </div>
          <div class="review-analysis-header-detail">
            <span>上期: {{ data.oldCount }}</span>
            <ChainRatio :percent="data.proportion"/>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="review-analysis-header-item item-1">
          <div class="review-analysis-header-title">
            Review好评数
          </div>
          <div class="review-analysis-header-number">
            {{ data.goodCount }}
          </div>
          <div class="review-analysis-header-detail">
            <span>上期: {{ data.goodOldCount }}</span>
            <ChainRatio :percent="data.goodProportion"/>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="review-analysis-header-item item-2">
          <div class="review-analysis-header-title">
            Review中差评数
          </div>
          <div class="review-analysis-header-number">
            {{ data.noCount }}
          </div>
          <div class="review-analysis-header-detail">
            <span>上期: {{ data.noOldCount }}</span>
            <ChainRatio :percent="data.noProportion"/>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="review-analysis-header-item item-3">
          <div class="review-analysis-header-title">
            留评率
          </div>
          <div class="review-analysis-header-number">
            {{ data.leaveReview ? data.leaveReview + "%" : ''}}
          </div>
          <div class="review-analysis-header-detail">
            <span>上期: {{ data.oldLeaveReview ? data.oldLeaveReview  + "%" : ''}}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ChainRatio from "@/views/components/chain-ratio/chain-ratio"

export default {
  name: "review-analysis-header",
  props:{
    data:{
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: { ChainRatio },
  data() {
    return {
      list: [],
    }
  }
}
</script>

<style scoped>
.review-analysis-header {

}
.review-analysis-header-item{
  border: 1px solid #e8e8e8;
  border-left: 4px solid #1F6EEF;
  padding: 17px 0 17px 34px;
  box-sizing: border-box;
  border-radius: 4px;
  min-height: 117px;
}
.item-1{
  border-left-color: #2DC079;
}
.item-2{
  border-left-color: #FF5656;
}
.item-3{
  border-left-color: #DC6AF8;
}
.review-analysis-header-title{
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  color: #999999;
  opacity: 1;
  /*margin-top: 17px;*/
}
.review-analysis-header-number{
  font-size: 24px;
  /*font-weight: bold;*/
  line-height: 31px;
  color: #333333;
  opacity: 1;
  margin-top: 8px;
}
.review-analysis-header-detail{
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #666666;
  opacity: 1;
  margin-top: 10px;
  padding-right: 30px;
  box-sizing: border-box;
}
.review-analysis-header-detail>span:nth-child(2){
  float: right;
}
</style>
